import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "app/api";

export interface RefreshTokenOssRequest {
  refresh_token: string;
}

export interface UserInfoOssRequest {
  access_token: string;
}

export interface RefreshTokenOssResponse {
  code: number;
  desc: string;
  data: {
    access_token: string;
    expired_aToken: string;
  }
}

export interface UserInfoOssResponse {
  status: number;
  message: string;
  data: {
    id_profile: number;
    username: string;
    kode_Instansi: string;
    jenis_identitas: string;
    nomor_identitas: string;
    nama: string;
    email: string;
    alamat: string;
    telp: string;
    status: string;
    role: string;
    flag_umk: string;
    foto: string;
    nama_kota: string;
    jenis_perseroan: string;
    flag_migrasi: string;
    kantor: string;
    unit_kerja: string;
    npwp_perseroan: string;
    jenis_pelakuUsaha: string;
  }
}

export const refreshTokenOss = createAsyncThunk(
  "refreshTokenOss",
  async (data: RefreshTokenOssRequest, thunkAPI) => {
    const config = {
      method: "post",
      url: "oss/sso/update-token",
      data: null,
      params: {
        refresh_token: data.refresh_token
      }
    };

    return api(config).then(
      (res: any) => {
        return res.data;
      },
      (err: any) => {
        return thunkAPI.rejectWithValue(err.response.data.message);
      }
    );
  }
);

export const userInfoOss = createAsyncThunk(
  "userInfoOss",
  async (data: UserInfoOssRequest, thunkAPI) => {
    const config = {
      method: "post",
      url: "oss/sso/userinfo",
      data: null,
      params: {
        access_token: data.access_token
      }
    };

    return api(config).then(
      (res: any) => {
        return res.data;
      },
      (err: any) => {
        return thunkAPI.rejectWithValue(err.response.data.message);
      }
    );
  }
);

const OssAuthSlice = createSlice({
  name: "OssAuthSlice",
  initialState: {
    dataRefreshTokenOss: { code: 0, desc: "", data: { access_token: "", expired_aToken: "" } } as RefreshTokenOssResponse,
    dataUserInfoOss: {
      status: 0,
      message: "",
      data: {
        id_profile: 0,
        username: "",
        kode_Instansi: "",
        jenis_identitas: "",
        nomor_identitas: "",
        nama: "",
        email: "",
        alamat: "",
        telp: "",
        status: "",
        role: "",
        flag_umk: "",
        foto: "",
        nama_kota: "",
        jenis_perseroan: "",
        flag_migrasi: "",
        kantor: "",
        unit_kerja: "",
        npwp_perseroan: "",
        jenis_pelakuUsaha: "",
      }
    } as UserInfoOssResponse,
    isFetching: false,
    isSuccessRefreshToken: false,
    isSuccessUserInfo: false,
    isError: false,
    errorMessage: "" as string,
  },
  reducers: {
    clearState: (state, action) => {
      state.isFetching = false;
      state.isSuccessRefreshToken = false;
      state.isSuccessUserInfo = false;
      state.isError = false;
      state.errorMessage = "";
    },
  },
  extraReducers: (builder) => {
    // refreshTokenOss
    builder.addCase(refreshTokenOss.fulfilled, (state, { payload }) => {
      state.isFetching = false;
      state.dataRefreshTokenOss = payload;
      state.isSuccessRefreshToken = true;
      return state;
    });
    builder.addCase(refreshTokenOss.rejected, (state, payload: any) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload.payload;
    });
    builder.addCase(refreshTokenOss.pending, (state, action) => {
      state.isFetching = true;
    });

    // userInfoOss
    builder.addCase(userInfoOss.fulfilled, (state, { payload }) => {
      state.isFetching = false;
      state.dataUserInfoOss = payload;
      state.isSuccessUserInfo = true;
      return state;
    });
    builder.addCase(userInfoOss.rejected, (state, payload: any) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload.payload;
    });
    builder.addCase(userInfoOss.pending, (state, action) => {
      state.isFetching = true;
    });
  },
});

export const { clearState } = OssAuthSlice.actions;
export default OssAuthSlice.reducer;
